/**
 * The surface-difference and deviation workers register byproducts per run
 * that back the Station Volumes dock: `<stem>_stations.json`,
 * `<stem>_stations.csv`, `<stem>_station_offsets.f32`, (spec §13.7)
 * `<stem>_station_bins.geojson` and the true station-line sections
 * `<stem>_station_sections.f32` / `<stem>_station_sections.csv`. Both workers
 * register all six — the list has to be kept in step with
 * `shared/stationVolumesMeta.ts`, whose `byproducts` map has the same six
 * keys. They are internal data the dock loads and
 * presents itself (its Export menu builds the CSV/TSV a user actually wants),
 * so they must never show up as raw downloads in the byproducts lists —
 * `SurfaceDifferencePanel.tsx`'s batch list and `Layers.tsx`'s per-layer
 * "Download byproduct" menu both filter on this predicate.
 *
 * Deliberately NOT used by `useStationVolumes.ts`, which resolves these same
 * files by filename on purpose to load them into the dock.
 */
export const isStationVolumesByproduct = (filename: string): boolean =>
  // `_station_sections.csv` is NOT matched by the `_stations\.csv` arm — the
  // stems differ — which is how both section files leaked into the raw
  // download lists when they were added.
  /_stations\.(json|csv)$|_station_offsets\.f32$|_station_bins\.geojson$|_station_sections\.(f32|csv)$/.test(
    filename,
  );
